import { AuthNoticeService } from './../../../shared/services/auth-notice.service';
import { AfterViewInit, Component, OnInit, OnDestroy, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { finalize, Subject, Subscription, takeUntil, tap } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { ReiniciarPassword } from 'src/app/shared/services/ReiniciarPassword';
import { fadeInUpAnimation } from 'src/app/shared/ui/fade-in-up.animation';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.scss'],
  animations: [fadeInUpAnimation],
  encapsulation: ViewEncapsulation.None
})

/**
 * Reset-password component
 */
export class PasswordresetComponent implements OnInit, OnDestroy {
  public loadingMessage: string = 'Cargando...';
	public disableLabel: boolean = false;
	private subscription: Subscription;
	public showButtonLogin: boolean = false;
	private unsubscribe: Subject<any>; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	loadIndicatorVisible = false;
	buttonText = 'Enviar';
	buttonTextSecond = 'Atrás';
	forgotPasswordForm: FormGroup;
	disabledButton = false;
	errors: any = [];
	segundos: number = 60;
	form: FormGroup;
	inputType = 'password';
	visible = false;


	constructor(
		private auth: AuthenticationService,
		public authNoticeService: AuthNoticeService,
		private translate: TranslateService,
		private router: Router,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef
	) {
		this.unsubscribe = new Subject();
	}

	ngOnInit() {
    document.body.setAttribute('class', 'authentication-bg');
		this.initRegistrationForm();
	}

	ngOnDestroy(): void {
    document.body.classList.remove('authentication-bg');
		this.unsubscribe.complete();
		this.disabledButton = false;
	}

	/**
	 * Form initalization
	 */
	initRegistrationForm() {
		this.forgotPasswordForm = this.fb.group({
			email: ['', Validators.compose([
				Validators.required,
				Validators.email,
				Validators.minLength(3),
				Validators.maxLength(320)
			])
			]
		});
	}

	/**
	 * Form Submit
	 */
	submit() {
    this.loadIndicatorVisible = true;
    this.buttonText = 'Cargando...';
    this.disabledButton = true;

    const controls = this.forgotPasswordForm.controls;
    if (this.forgotPasswordForm.invalid) {
        this.loadIndicatorVisible = false;
        Object.keys(controls).forEach(controlName =>
            controls[controlName].markAsTouched()
        );
        return;
    }

    const email = controls['email'].value;
    this.auth.solicitarCambioPasswordByEmail(email)
    .subscribe(result => {
			this.forgotPasswordForm.reset()
			this.disableLabel = true;
            this.loadIndicatorVisible = false;
            this.buttonText = 'Enviar';
            this.disabledButton = false;
			this.showButtonLogin = true;
        }, (err) => {
            Swal.fire({
                title: '¡Ops!',
                text: 'Ocurrió un error en el servicio.',
                icon: 'error',
                confirmButtonColor: '#008000',
                confirmButtonText: 'Continuar'
            });
            this.loadIndicatorVisible = false;
            this.buttonText = 'Enviar';
            this.disabledButton = false;
        }
    );
}



	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.forgotPasswordForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result =
			control.hasError(validationType) &&
			(control.dirty || control.touched);
		return result;
	}

	login(){
		this.router.navigateByUrl('/login')
	  }

}
